// Opt-in development review: never enabled by a production build.
export const STUDIO_LOCAL_ONLY = process.env.NODE_ENV !== 'production' && process.env.REACT_APP_STUDIO_LOCAL_ONLY === 'true';
export function assertStudioCloudWrite() {
  if (STUDIO_LOCAL_ONLY) throw new Error('Local review mode: cloud changes are disabled. Use Save locally.');
}
